import { Lock } from "lucide-react";

interface FooterLinkGroupProps {
  title: string;
  links: { text: string; href: string }[];
}

function FooterLinkGroup({ title, links }: FooterLinkGroupProps) {
  return (
    <div>
      <h4 className="mb-4 text-sm font-semibold tracking-wider text-zinc-200 uppercase">
        {title}
      </h4>
      <ul className="space-y-2">
        {links.map((link) => (
          <li key={link.text}>
            <a
              href={link.href}
              className="text-sm text-zinc-400 transition-colors hover:text-white"
            >
              {link.text}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}

export function Footer() {
  const footerLinkGroups = [
    {
      title: "Product",
      links: [
        { text: "Features", href: "#features" },
        { text: "How It Works", href: "#how-it-works" },
        { text: "Pricing", href: "#pricing" },
      ],
    },
    {
      title: "Legal & Security",
      links: [
        { text: "Security Architecture", href: "#features" },
        { text: "Privacy Policy", href: "#" },
        { text: "Terms of Service", href: "#" },
      ],
    },
  ];

  return (
    <footer className="border-t border-zinc-800 bg-zinc-950 py-16 text-white">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-3">
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <Lock className="h-6 w-6 text-zinc-200" />
              <span className="text-xl font-bold tracking-tight text-white">
                Secure Legacy
              </span>
            </div>
            <p className="max-w-xs text-sm leading-relaxed text-zinc-400">
              The fully branded digital vault for estate and life planning. Your
              clients stay in control today; you guide access for their
              nominated trustees when the time comes.
            </p>
          </div>

          {footerLinkGroups.map((group) => (
            <FooterLinkGroup
              key={group.title}
              title={group.title}
              links={group.links}
            />
          ))}
        </div>

        <div className="mt-12 border-t border-zinc-800 pt-8">
          <p className="text-sm text-zinc-500">
            © {new Date().getFullYear()} Secure Legacy. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
